import { render, staticRenderFns } from "./update-version.vue?vue&type=template&id=24692e64&"
import script from "./update-version.vue?vue&type=script&lang=js&"
export * from "./update-version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "update-version.vue"
export default component.exports